<header class="site-header" [class.scrolled]="isScrolled">
  <!-- Home icon -->
  <a class="home-btn" routerLink="/" aria-label="Go to home">
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
    </svg>
  </a>

  <!-- Hamburger button -->
  <button class="hamburger-btn" (click)="toggleMenu()" [class.open]="menuOpen" aria-label="Toggle menu">
    <span class="bar"></span>
    <span class="bar"></span>
    <span class="bar"></span>
  </button>
</header>

<!-- Spacer: reserves in-flow height so page content clears the fixed bar -->
<div class="header-spacer" aria-hidden="true"></div>

<!-- Backdrop -->
<div class="menu-backdrop" [class.visible]="menuOpen" (click)="menuOpen = false"></div>

<!-- Slide-out drawer -->
<nav class="menu-drawer" [class.open]="menuOpen" aria-hidden="!menuOpen">
  <div class="drawer-header">
    <span class="drawer-title">Navigation</span>
    <button class="drawer-close-btn" (click)="menuOpen = false" aria-label="Close menu">✕</button>
  </div>

  <ul class="nav-list">
    <li *ngFor="let item of visibleItems">
      <button class="nav-item" (click)="navigate(item.path)" [class.active]="router.url === item.path">
        <span class="nav-emoji">{{ item.emoji }}</span>
        <span class="nav-label">{{ item.label }}</span>
      </button>
    </li>
  </ul>

  <div class="drawer-footer" *ngIf="isLoggedIn">
    <span class="logged-in-badge">● Signed in</span>
  </div>
</nav>
